import script from "./SelectRole.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectRole.vue?vue&type=script&setup=true&lang=ts"

import "./SelectRole.vue?vue&type=style&index=0&id=6da2886d&scope=true&lang=css"

const __exports__ = script;

export default __exports__